{
    "es": "Español",
    "en": "Inglés"
}
